import MemberActionAssignBadgeDetails from '@/screens/MemberActionAssignBadge/MemberActionAssignBadgeDetails';

export default MemberActionAssignBadgeDetails;
